<template>
	<v-layout row wrap>
		<v-flex xs12 pl-1 pr-2>
			<v-card class="flex">
				<v-toolbar flat color="grey lighten-4">
					<v-toolbar-title class="grey--text text--darken-2">Appuntamenti</v-toolbar-title>
					<v-spacer></v-spacer>   
					<v-toolbar-items>
						<v-btn icon @click="showTable = !showTable">
							<v-icon>storage</v-icon>
						</v-btn>
					</v-toolbar-items>					                              
				</v-toolbar>
				<v-divider></v-divider>

				<v-layout v-if="loaded" row wrap px-4 py-2>
					<v-flex xs6 sm6 md6 lg3 py-0 pr-3>
						<v-select 
							:items="fieldsset.year.options"
							v-model="model['year']"
							hint="Anno"
							persistent-hint
							single-line
							dense
							box
						></v-select>
					</v-flex>
					<v-flex xs6 sm6 md6 lg9 py-0 px-3>
						<v-select 
							:items="fieldsset.calendar_id.options"
							v-model="model['calendar_id']"
							hint="Calendario"
							persistent-hint
							single-line
							dense
							multiple
							small-chips
							box
						></v-select>
					</v-flex>							
				</v-layout>

				<curved-columns v-if="!showTable"
					:chart-data="events"
				></curved-columns>
				<v-data-table v-else
					:headers="headers"
					:items="events"
					hide-actions>
					<template slot="items" slot-scope="props">
						<tr class="cursor-pointer">
							<template v-for="(header, h) in headers">
								<td :key="h">
									{{ props.item[header.value] }}
								</td>
							</template>
						</tr>
					</template>				
				</v-data-table>
				<v-divider></v-divider>
				<v-card-text class="title font-weight-thin text-xs-center pa-4"> Totale Appuntamenti: {{ totalEvents }}</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</template>

<script>

	import Vue from 'vue'
	import CurvedColumns from '@/components/statistic/CurvedColumns'

	export default {
		name: 'events-chart',
		components: {
			CurvedColumns
		},
		props: {},

		data() {
			return {
				model: {},
				events: [],
				fieldsset: {},
				loaded: false,
				showTable: false,
                headers: [
                    {
                        'text': '#',
                        'value': 'order'
                    },
                    {
                        'text': 'Mese',
                        'value': 'month'
                    },
                    {
                        'text': 'Quantità',
                        'value': 'quantity'
                    }
                ]				
			}
		},

		computed: {
			totalEvents() {
				if(this.events.length > 0) {
					return this.events.reduce((acc, event) => acc + event.quantity, 0);
				} else {
					return 0
				}
			}
		},

		watch: {
			model: {
				handler() {
					this.getData()
				},
				deep: true,
				immediate: true,
			},
		},

		created() {
			this.axios.get('events-chart-info').then(response => {
				this.fieldsset = response.data.info.fields
				_.forEach(this.fieldsset, (value, key) => {
				    if(value.default) {
				        Vue.set(this.model, value.key, value.default)
				    }
				})				
				this.loaded = true				
			},
			response => {
				// error callback
			})
		},

		methods: {
			getData() {
				this.axios.post('events-chart', this.model).then(response => {
					// get body data
					this.events = response.data.data
					this.$store.commit('endProgress')
				},
				response => {
					// error callback
				})
			},
		}
	}
</script>

<style>
	#events-categoryaxis {
	width: 100%;
	height: 500px;
	}
</style>
